import { createStore } from 'vuex';

export default createStore({
  state: {
    hostname: 'www.german-films.de',
    site: '/activities/annual-selection', // wird automatisch gesetzt
    extensionName: 'tx_snmoviedb',
    pluginName: 'moviedb',
    dummyPicture: 'fileadmin/mediapool/IMAGES/Filmarchive/platzhalter_film_archive.jpg',
    selectedFilmCard: 0,
    selectedPersonCard: 0,
    selectedCompanyCard: 0,
    counter: 0,
    idForSearchRequest: [],
    wholeDatabase: [],
    company: null,
    person: null,
    searchURL: '',
    fetchError: 0,
    completedLoading: false,
    vueURL: '',
  },
  mutations: {
    updateSite(state, data) {
      this.state.site = data.slice(0, -1);
      console.log('this.state.site');
      console.log(this.state.site);
    },
    updateCompany(state, data) {
      this.state.company = data;
    },
    updatePerson(state, data) {
      this.state.person = data;
    },
    updateVueURL(state, data) {
      this.state.vueURL = data;
    },
    updateDate(state, data) {
      this.state.oldestFilm = data;
    },
    updateURL(state, URL) {
      // eslint-disable-next-line no-param-reassign
      state.searchURL = URL;
    },
    async updateSelectedFilmCard(state, id) {
      let fetchSeperate = true;
      // eslint-disable-next-line consistent-return
      await this.state.wholeDatabase.forEach((film) => {
        if (film.uid === id || id === 0) {
          this.state.selectedFilmCard = id;
          fetchSeperate = false;
        }
      });
      if (fetchSeperate) {
        // eslint-disable-next-line no-param-reassign
        state.selectedFilmCard = 0;
        await fetch(
          `https://${state.hostname}/?tx_snmoviedb_moviedb[filter][answerType]=items&tx_snmoviedb_moviedb[items]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.itemList[0].uid) {
              await state.wholeDatabase.push(data.itemList[0]);
              this.state.selectedFilmCard = id;
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            // this.completeLoading(true);
            this.state.fetchError = 1;
          });
      }
    },
    async updateSelectedPersonCard(state, id) {
      if (id !== 0) {
        await fetch(
          `https://${state.hostname}${this.state.site}?tx_snmoviedb_moviedb[action]=special&tx_snmoviedb_moviedb[controller]=Film&tx_snmoviedb_moviedb[filter][answerType]=person&tx_snmoviedb_moviedb[person]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.personFilmList.personData.firstname || data.personFilmList.personData.name) {
              this.state.person = data.personFilmList;
              this.state.selectedPersonCard = id;
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            this.state.fetchError = 1;
          });
      } else {
        this.state.selectedPersonCard = id;
      }
    },
    async updateSelectedCompanyCard(state, id) {
      if (id !== 0) {
        await fetch(
          `https://${state.hostname}${this.state.site}?tx_snmoviedb_moviedb[action]=special&tx_snmoviedb_moviedb[controller]=Film&tx_snmoviedb_moviedb[filter][answerType]=company&tx_snmoviedb_moviedb[company]=${id}&type=2753189517`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
          },
        )
          .then((response) => response.json())
          .then(async (data) => {
            if (data.companyFilmList.companyData.title) {
              this.state.company = data.companyFilmList;
              this.state.selectedCompanyCard = id;
            } else {
              window.location.href = '/404';
            }
          }).catch(() => {
            this.state.fetchError = 1;
          });
      } else {
        this.state.selectedCompanyCard = id;
      }
    },
    updateIdForSearchRequest(state, data) {
      this.state.idForSearchRequest = data;
    },
    updateCounter(state, data) {
      this.state.counter += data;
      if (data === 0) {
        this.state.counter = 0;
      }
    },
    async updateWholeDatabase(state, data) {
      /* eslint-disable no-param-reassign */
      await data.forEach((film) => {
        state.wholeDatabase.push(film);
        const filename = film.identifier;
        if (filename.length !== 0) {
          if (filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'jpeg'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'jpg'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'png'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'gif'
              && filename[0].substring(filename[0].lastIndexOf('.') + 1, filename[0].length).toLowerCase() !== 'bmp') {
            film.identifier = '';
          }
        }
      });
    },
    clearEntries(state) {
      // eslint-disable-next-line no-param-reassign
      state.wholeDatabase = [];
    },
    updateError(state, error) {
      // eslint-disable-next-line no-param-reassign
      state.fetchError = error;
    },
    completeLoading(state, a) {
      // eslint-disable-next-line no-param-reassign
      state.completedLoading = a;
    },
  },
});
